import { forwardRef } from 'react';

import { ProcessorProvider } from '../../providers/ProcessorProvider';
import { ProcessorConfigs } from '../../../@types';
import { SupportedProcessors } from '../../../constants';

import { StripePaymentForm } from './StripePaymentForm';
import { StripePaymentFormProps } from './paymentElement.types';

type StripePaymentElementProps = {
  processors: ProcessorConfigs;
  paymentMethodConfiguration?: string | null;
  amount: number;
  currency?: string;
} & StripePaymentFormProps;

export const StripePaymentElement = forwardRef(
  (
    {
      processors,
      paymentMethodConfiguration,
      amount,
      currency = 'usd',
      onPaymentMethodChange,
      onSubmit,
      onError,
    }: StripePaymentElementProps,
    fwdRef: any,
  ) => {
    return (
      <>
        {paymentMethodConfiguration ? (
          <ProcessorProvider
            key="stripe-payment-element"
            method="payment_element"
            methodConfig={{
              processor: SupportedProcessors.STRIPE,
              paymentMethodConfiguration,
            }}
            billingConfig={{}}
            processors={processors}
            options={{ amount, currency }}
          >
            {/*
            TODO: if we ever want to have here not only Stripe,
            we need to replace this with some generic and render props for each provider.
          */}
            <StripePaymentForm
              onSubmit={onSubmit}
              onError={onError}
              onPaymentMethodChange={onPaymentMethodChange}
              paymentMethodConfiguration={paymentMethodConfiguration}
              ref={fwdRef}
            />
          </ProcessorProvider>
        ) : null}
      </>
    );
  },
);

export * from './events';
